/* tslint:disable */
/* eslint-disable */
/**
 * Vividi Dashboard API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MultiDeviceOutagesRequestBody
 */
export interface MultiDeviceOutagesRequestBody {
    /**
     * 
     * @type {string}
     * @memberof MultiDeviceOutagesRequestBody
     */
    startingFrom: string;
    /**
     * 
     * @type {string}
     * @memberof MultiDeviceOutagesRequestBody
     */
    endingAt: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof MultiDeviceOutagesRequestBody
     */
    sceneIds: Array<number>;
}

export function MultiDeviceOutagesRequestBodyFromJSON(json: any): MultiDeviceOutagesRequestBody {
    return MultiDeviceOutagesRequestBodyFromJSONTyped(json, false);
}

export function MultiDeviceOutagesRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): MultiDeviceOutagesRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'startingFrom': json['starting_from'],
        'endingAt': json['ending_at'],
        'sceneIds': json['scene_ids'],
    };
}

export function MultiDeviceOutagesRequestBodyToJSON(value?: MultiDeviceOutagesRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'starting_from': value.startingFrom,
        'ending_at': value.endingAt,
        'scene_ids': value.sceneIds,
    };
}

